import Components from "slotworks/components/components";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class GambleControl extends AbstractControl {
    private gambleBtn: FlexiButton;
    private collectBtn: FlexiButton;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        switch (assetNames.length) {
            case 1:
                this.collectBtn = layer.getFlexiButton(assetNames[0]);
                if (this.collectBtn) {
                    this.collectBtn.on(ButtonEvent.CLICK, () => Components.gamble.collect());
                }
                break;
            case 2:
                this.gambleBtn = layer.getFlexiButton(assetNames[0]);
                if (this.gambleBtn) {
                    this.gambleBtn.on(ButtonEvent.CLICK, () => Components.gamble.start());
                }

                this.collectBtn = layer.getFlexiButton(assetNames[1]);
                if (this.collectBtn) {
                    this.collectBtn.on(ButtonEvent.CLICK, () => Components.gamble.collect());
                }

                break;
        }
    }

    public setEnabled(enabled: boolean): void {
        super.setEnabled(enabled);
        if (this.gambleBtn) {
            this.gambleBtn.setEnabled(enabled);
        }
        if (this.collectBtn) {
            this.collectBtn.setEnabled(enabled);
        }
    }
}
